import "./index.css";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";

import { Authenticator } from "@aws-amplify/ui-react";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./containers/App";
import reportWebVitals from "./reportWebVitals";
import { configureStore } from "./store";
import { Toaster } from "./util/toaster";

const store = configureStore();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Toaster></Toaster>
      <Authenticator.Provider>
        <App />
      </Authenticator.Provider>
    </Provider>
  </React.StrictMode>,
  document.getElementById( "root" )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
